import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { PurchasableStateMeta } from "./PurchasableStateMeta";

export const CardStaffMetaFields = {
  assignId: propertyMeta("assignId", false, true, false, MetaTypesBase.number),
  issueDate: propertyMeta("issueDate", false, false, false, MetaTypesBase.Date),
  cardNum: propertyMeta("cardNum", false, true, false, MetaTypesBase.string),
  temp: propertyMeta("temp", false, true, false, MetaTypesBase.boolean),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  paid: propertyMeta("paid", false, false, false, MetaTypesBase.string),
  price: propertyMeta("price", false, false, false, MetaTypesBase.currency),
  purchaseDate: propertyMeta("purchaseDate", false, false, false, MetaTypesBase.Date),
  purchasableState: propertyMeta("purchasableState", false, true, false, PurchasableStateMeta),
  voidCloseId: propertyMeta("voidCloseId", false, false, false, MetaTypesBase.number),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
};

export const CardStaffMeta = typeMeta("CardStaff", CardStaffMetaFields);
